import { Post } from '../http/httpVerbs';

export const apiPostDesafioCreator = async (data) => {
    try {
        const response = await Post(`${process.env.REACT_APP_API_URL}/desafios/creators`, data);
        return response;
    } catch (error) {
        throw error;
    }
};
